<template>
  <div id="top">
    <div class="page-header clear-filter" filter-color="dark">
      <parallax class="page-header-image" style="background-image:url('img/bg-panel-00.jpg')"></parallax>
      <div class="content-center">
        <div class="container">
          <div class="content-center brand">
            <h1 class="h1-seo">Eficiencia Energética y Seguridad</h1>
            <h3>MONITOREO, CONTROL, AUTOMATIZACIÓN, DETECCIÓN, ACCIÓN Y SEGURIDAD.</h3>
          </div>
        </div>
      </div>
      <vue-particles color="#bbbbbb" :particleOpacity="0.5" :lineOpacity="0.3" :clickEffect="false"></vue-particles>
      <router-link class="scroll-btn link-scroll" to="/#about" @click.native="scrollFix('#about')">
        <i class="fa fa-chevron-down"></i>
      </router-link>
    </div>
    <div id="about" class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h2 class="title">¿Quiénes somos?</h2>
            <h4 class="description">
              {{social.description}}
              <br />
              <br />Contamos con 2 departamentos de trabajo:
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 offset-md-2">
            <div class="info info-hover">
              <div class="icon text-primary">
                <i class="fas fa-tools"></i>
              </div>
              <h4 class="description info-title">
                Departamento de
                <br />Infraestructura
              </h4>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info info-hover">
              <div class="icon text-primary">
                <i class="fas fa-code"></i>
              </div>
              <h4 class="description info-title">
                Departamento de
                <br />Desarrollo
              </h4>
            </div>
          </div>
        </div>
        <div class="section-story-overview">
          <div class="row">
            <div class="col-md-10 ml-auto mr-auto text-center">
              <div>
                <h3>Nuestra Misión</h3>
                <h4
                  class="description"
                >Crear la pronta solución para las necesidades, brindándoles la mejor calidad, respuesta, cooperación, ética profesional e innovación del mercado.</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="section-story-overview pt-0">
          <div class="row">
            <div class="col-md-10 ml-auto mr-auto text-center">
              <h3>Nuestra Visión</h3>
              <h4
                class="description"
              >Ser una organización líder e innovadora, reconocida como tal por nuestros clientes y proveedores, valiéndonos de sistemas de gestión integrados y automatizados. Desarrollar un equipo humano competente, en un clima empresarial abierto y de confianza, que promueva la innovación y mejora continua, permitiéndonos ofrecer ingeniería, proyectos y servicios especializados en alta calidad</h4>
            </div>
          </div>
        </div>
        <div class="section-story-overview py-0">
          <div class="row">
            <div class="col-md-10 ml-auto mr-auto text-center">
              <h3 class="mb-0">Nuestros Valores</h3>
            </div>
            <div class="col-12">
              <ul class="grid">
                <grid-item
                  styles="sm rounded no-border"
                  icon="far fa-lightbulb"
                  icon-color="text-primary"
                >
                  <template>Innovación</template>
                </grid-item>
                <grid-item
                  styles="sm rounded no-border"
                  icon="far fa-thumbs-up"
                  icon-color="text-primary"
                >
                  <template>Atención</template>
                </grid-item>
                <grid-item
                  styles="sm rounded no-border"
                  icon="far fa-handshake"
                  icon-color="text-primary"
                >
                  <template>Compromiso</template>
                </grid-item>
                <grid-item
                  styles="sm rounded no-border"
                  icon="fas fa-chart-line"
                  icon-color="text-primary"
                >
                  <template>Competitividad</template>
                </grid-item>
                <grid-item
                  styles="sm rounded no-border"
                  icon="fas fa-user-secret"
                  icon-color="text-primary"
                >
                  <template>Ética profesional</template>
                </grid-item>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="services" class="section section-services">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h2 class="title">Nuestros Servicios</h2>
          </div>
        </div>
        <div class="section-story-overview pt-0">
          <div class="row">
            <div class="col-md-10 ml-auto mr-auto text-center">
              <h3 class="text-center mb-0"><router-link to="/infrastructure-services">Servicios del Departamento de Infraestructura</router-link></h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-lg-3">
              <div class="info info-hover">
                <div class="icon icon-circle text-primary">
                  <i class="fas fa-network-wired"></i>
                </div>
                <h4 class="description info-title">Cableado estructurado y fibra óptica</h4>
              </div>
            </div>
            <div class="col-md-4 col-lg-3">
              <div class="info info-hover">
                <div class="icon icon-circle text-primary">
                  <i class="fas fa-door-open"></i>
                </div>
                <h4 class="description info-title">Control de Accesos</h4>
              </div>
            </div>
            <!-- <div class="col-md-4 col-lg-2">
              <div class="info info-hover">
                <div class="icon icon-circle text-primary">
                  <i class="fas fa-tv"></i>
                </div>
                <h4 class="description info-title">Sistemas CCTV</h4>
              </div>
            </div> -->
            <div class="col-md-4 col-lg-3">
              <div class="info info-hover">
                <div class="icon icon-circle text-primary">
                  <i class="fas fa-fire-extinguisher"></i>
                </div>
                <h4 class="description info-title">Sistemas de Prevención y Supresión de Incendios</h4>
              </div>
            </div>
            <div class="col-md-4 offset-md-4 col-lg-3 offset-lg-0">
              <div class="info info-hover">
                <div class="icon icon-circle text-primary">
                  <i class="fas fa-laptop-house"></i>
                </div>
                <h4 class="description info-title">Automatización industrial y residencial</h4>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="section-story-overview pt-0">
          <div class="row">
            <div class="col-md-12 d-flex align-items-center justify-content-center">
              <router-link to="/infrastructure-services" class="btn btn-simple btn-round btn-primary btn-lg">
                <h5 class="m-0">
                  Conocer más
                  <i class="fas fa-chevron-right fa-lg vertical-align-middle ml-1"></i>
                </h5>
              </router-link>
            </div>
          </div>
        </div> -->

        <div class="section-story-overview">
          <div class="row">
            <div class="col-md-10 ml-auto mr-auto text-center">
              <h3 class="text-center mb-0"><router-link to="/technology-services">Servicios del Departamento de Desarrollo</router-link></h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-lg-3">
              <div class="info info-hover">
                <div class="icon icon-circle text-primary">
                  <i class="fas fa-code"></i>
                </div>
                <h4 class="description info-title">Desarrollo de software a medida</h4>
              </div>
            </div>
            <div class="col-md-4 col-lg-3">
              <div class="info info-hover">
                <div class="icon icon-circle text-primary">
                  <i class="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 class="description info-title">Consultoría</h4>
              </div>
            </div>
            <div class="col-md-4 col-lg-3">
              <div class="info info-hover">
                <div class="icon icon-circle text-primary">
                  <i class="fas fa-mobile-alt"></i>
                </div>
                <h4 class="description info-title">Desarrollo de aplicaciones móviles</h4>
              </div>
            </div>
            <div class="col-md-4 offset-md-4 col-lg-3 offset-lg-0">
              <div class="info info-hover">
                <div class="icon icon-circle text-primary">
                  <i class="fas fa-laptop-code"></i>
                </div>
                <h4 class="description info-title">Desarrollo de apps web</h4>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="section-story-overview py-0">
          <div class="row">
            <div class="col-md-12 d-flex align-items-center justify-content-center">
              <router-link to="/technology-services" class="btn btn-simple btn-round btn-primary btn-lg">
                <h5 class="m-0">
                  Conocer más
                  <i class="fas fa-chevron-right fa-lg vertical-align-middle ml-1"></i>
                </h5>
              </router-link>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div id="projects" class="section section-projects">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Nuestros proyectos</h2>
          </div>
        </div>

        <two-columns position-text="left" centered>
          <template>
            <h3>QUOTE</h3>
            <p
              class="description text-justify"
            >Plataforma y sistema para cotizaciones en línea, manejo de negocios, postulaciones y horas laborales y control de cambios en el proyecto.</p>
          </template>
          <template slot="right-text">
            <img
              src="img/projects/quote-desktop2.png"
              class="img-fluid"
              style="max-height: 350px"
              alt="access-control"
            />
          </template>
        </two-columns>

        <two-columns centered>
          <template>
            <h3>DOCTOR +</h3>
            <p
              class="description text-justify"
            >Plataforma para video citas en línea, llamadas y video llamadas.</p>
            <p
              class="description text-justify"
            >Mensajería en tiempo real, calendario de citas de paciente a médico.</p>
          </template>
          <template slot="right-text">
            <img
              src="img/projects/doctor-mobile2.png"
              class="img-fluid"
              style="max-height: 400px"
              alt="access-control"
            />
          </template>
        </two-columns>

         <div class="section-story-overview pb-0">
          <div class="row">
            <div class="col-md-12 d-flex align-items-center justify-content-center">
              <router-link to="/projects" class="btn btn-simple btn-round btn-primary btn-lg">
                <h5 class="m-0">
                  Conocer más
                  <i class="fas fa-chevron-right fa-lg vertical-align-middle ml-1"></i>
                </h5>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="team" class="section section-team text-center">
      <div class="container">
        <h2 class="title">Nuestro Equipo</h2>
        <div class="team mb-5">
          <div class="row">
            <div class="col-12 col-lg-10 col-xl-9 mx-auto">
              <div class="grid-team">
                <team-avatar
                  name="Luis Duarte"
                  photo="img/ld-photo.jpg"
                  jobTitle="CEO"
                  twitter="luisduarte009"
                  facebook="luis.c.duarte.16"
                  linkedin="luis-carlos-duarte-iraheta-6b848414a"
                  github="luiscd7"
                ></team-avatar>
                <team-avatar
                  name="Monica Herrera"
                  photo="img/mh-photo.jpeg"
                  jobTitle="CFO"
                  twitter="moyoqui"
                  facebook="moyoqui"
                  linkedin="m%C3%B3nica-herrera-0179794b"
                ></team-avatar>
                <team-avatar
                  name="Ivan Flores"
                  photo="img/if-photo.jpg"
                  jobTitle="Director de Proyectos"
                  linkedin="leonardo-ivan-flores-ramos-21835290"
                ></team-avatar>
                <team-avatar
                  name="Eduardo Valencia"
                  photo="img/ev-photo.jpg"
                  jobTitle="Full Stack Developer"
                  twitter="eduard_gv93"
                  facebook="eduardo.gomezvalencia.77"
                  linkedin="enriquegomezv"
                  github="EnriqueV"
                ></team-avatar>
                <team-avatar
                  name="Diego Rodríguez"
                  photo="img/dm-photo.png"
                  jobTitle="Full Stack Developer"
                  facebook="RM314"
                  linkedin="diego-majano"
                  github="DiegoMajano"
                ></team-avatar>
                <team-avatar
                  name="Andrés Godinez"
                  photo="img/ag-photo.jpg"
                  jobTitle="Full Stack Developer"
                  twitter="agodin3z"
                  linkedin="agodin3z"
                  github="agodin3z"
                  gitlab="agodin3z"
                ></team-avatar>
                <team-avatar
                  name="Carlos Cárcamo"
                  photo="img/cc-photo.jpg"
                  jobTitle="DevOps"
                  twitter="_carloscarcamo_"
                  facebook="karloskarcamo"
                  linkedin="carloscarcamo"
                  github="carloscarcamom"
                ></team-avatar>
                <team-avatar
                  name="Roberto Turcios"
                  photo="img/rt-photo.jpg"
                  jobTitle="DevOps"
                  twitter="jupitersv"
                  facebook="lonegunman.ln"
                  github="jupitersv"
                ></team-avatar>
                <team-avatar
                  name="Fredy Suncin"
                  photo="img/fs-photo.jpeg"
                  jobTitle="Back-End Developer"
                  twitter="fredy_suncin"
                  facebook="fredy.suncin"
                  linkedin="suncin"
                  github="fredy-suncin"
                ></team-avatar>
              </div>
            </div>
          </div>
        </div>

        <div class="section-story-overview">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto text-center">
              <h3>Tecnologías que dominamos:</h3>
            </div>
            <div class="col-12">
              <ul class="grid pt-0">
                <grid-item styles="xs rounded no-border d-none d-sm-flex" no-margin @click.native="goto('https://www.typescriptlang.org/')">
                  <template>
                    <img src="img/tech/ts.png" alt="TypeScript" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://angular.io/')">
                  <template>
                    <img src="img/tech/angular.png" alt="Angular" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://es.reactjs.org/')">
                  <template>
                    <img src="img/tech/react.png" alt="React" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://vuejs.org/')">
                  <template>
                    <img src="img/tech/vue.png" alt="Vue.js" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border d-none d-sm-flex" no-margin @click.native="goto('https://nodejs.org/')">
                  <template>
                    <img src="img/tech/node.png" alt="NodeJS" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://expressjs.com/')">
                  <template>
                    <img src="img/tech/express.png" alt="Express" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://sequelize.org/')">
                  <template>
                    <img src="img/tech/sequelize.png" alt="Sequelize" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://ionicframework.com/')">
                  <template>
                    <img src="img/tech/ionic.png" alt="Ionic" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border d-none d-sm-flex" no-margin @click.native="goto('https://www.ruby-lang.org/')">
                  <template>
                    <img src="img/tech/ruby.png" alt="Ruby" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://rubyonrails.org/')">
                  <template>
                    <img src="img/tech/rails.png" alt="Ruby On Rails" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://www.python.org/')">
                  <template>
                    <img src="img/tech/python.png" alt="Python" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border d-none d-sm-flex" no-margin @click.native="goto('https://www.php.net/')">
                  <template>
                    <img src="img/tech/php.png" alt="PHP" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border d-none d-sm-flex" no-margin @click.native="goto('https://www.mysql.com/')">
                  <template>
                    <img src="img/tech/mysql.png" alt="MySQL" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border d-none d-sm-flex" no-margin @click.native="goto('https://www.postgresql.org/')">
                  <template>
                    <img src="img/tech/postgresql.png" alt="PostgreSQL" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border d-none d-sm-flex" no-margin @click.native="goto('https://www.java.com/')">
                  <template>
                    <img src="img/tech/java.png" alt="Java" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://www.android.com/')">
                  <template>
                    <img src="img/tech/android.png" alt="Android" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://developer.apple.com/swift/')">
                  <template>
                    <img src="img/tech/swift.png" alt="Swift" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://aws.amazon.com/')">
                  <template>
                    <img src="img/tech/aws.png" alt="Amazon Web Services" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border d-none d-sm-flex" no-margin @click.native="goto('https://jitsi.org/')">
                  <template>
                    <img src="img/tech/jitsi.png" alt="Jitsi" class="tech-img" />
                  </template>
                </grid-item>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="contact" class="section section-contact-us text-center">
      <div class="container">
        <h2 class="title">Contáctanos</h2>
        <p class="description">Tu proyecto es muy importante para nosotros.</p>
        <div class="row">
          <div class="col-lg-6 text-center ml-auto mr-auto col-md-8">
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(onSubmit)">
                <ValidationProvider name="firstname" rules="required" v-slot="{ errors }">
                  <fg-input
                    class="input-lg"
                    placeholder="Nombre..."
                    v-model="form.firstname"
                    name="firstname"
                    addon-left-icon="now-ui-icons users_circle-08"
                    @focus="sended = false"
                    :error="!sended && errors[0]"
                  ></fg-input>
                </ValidationProvider>
                <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                  <fg-input
                    class="input-lg"
                    placeholder="Correo Electrónico..."
                    v-model="form.email"
                    name="email"
                    addon-left-icon="now-ui-icons ui-1_email-85"
                    @focus="sended = false"
                    :error="!sended && errors[0]"
                  ></fg-input>
                </ValidationProvider>
                <ValidationProvider name="message" rules="required" v-slot="{ errors }">
                  <div
                    class="textarea-container input-group position-relative mt-2"
                    :class="{'has-danger': !sended && errors[0]}"
                  >
                    <textarea
                      class="form-control"
                      name="message"
                      rows="4"
                      cols="80"
                      v-model="form.message"
                      placeholder="Escriba un mensaje..."
                      @focus="sended = false"
                    ></textarea>
                    <div
                      class="text-danger invalid-feedback mt-2"
                      :class="{'d-block': !sended && errors[0]}"
                    >{{errors[0]}}</div>
                  </div>
                </ValidationProvider>
                <div class="send-button">
                  <n-button type="primary" round block size="lg" native-type="submit">Enviar Mensaje</n-button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueScrollTo from "vue-scrollto";
import axios from "axios";
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { Button, FormGroupInput, GridItem, TeamAvatar } from "@/components";

extend("required", {
  ...required,
  message: "Este campo es requerido"
});

extend("email", {
  ...email,
  message: "Correo Electrónico Inválido"
});

export default {
  name: "index",
  bodyClass: "landing-page",
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    GridItem,
    TeamAvatar,
    VueScrollTo: VueScrollTo,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      form: {
        firstname: "",
        email: "",
        message: ""
      },
      sended: false,
      social: {
        title: 'Consultoría en Tecnología, Seguridad y Energía | Proyectos SEES',
        description: 'En Proyectos SEES brindamos solucionesintegrales en tecnología, eficiencia energética, seguridad electrónica y mantenimiento IT.',
        image: 'https://proyectosees.com/img/ees-icon.png'
      }
    };
  },
  methods: {
    scrollFix: hashbang => {
      VueScrollTo.scrollTo(hashbang, 700);
    },
    onSubmit() {
      this.sended = false;
      const data = new FormData();
      data.append('firstname', this.form.firstname);
      data.append('email', this.form.email);
      data.append('message', this.form.message);

      axios
        .post("/mailer.php", data)
        .then(response => {
          this.form = {
            firstname: "",
            email: "",
            message: ""
          };
          this.sended = true;
        });
    },
    goto: url => {
      window.open(url, '_blank');
    }
  },
  head: {
    title: {
      inner: 'Consultoría en Tecnología, Seguridad y Energía'
    },
    // Meta tags
    meta() {
      return [
        { n: 'description', c: this.social.description, id: 'desc' },
        // Twitter
        { n: 'twitter:card', c: 'summary', id: 'twtca' },
        // { n: 'twitter:site', c: '@username', id: 'twtsi' },
        { n: 'twitter:title', c: this.social.title, id: 'twtti' },
        { n: 'twitter:description', c: this.social.description, id: 'twtde' },
        // { n: 'twitter:creator', c: '@username', id: 'twtcr' },
        { n: 'twitter:image', c: this.social.image, id: 'twtim' },
        // Google+ / Schema.org
        { itemprop: 'name', c: this.social.title, id: 'gglna' },
        { itemprop: 'description', c: this.social.description, id: 'gglde' },
        { itemprop: 'image', c: this.social.image, id: 'gglim' },
        // Facebook / Open Graph
        { p: 'og:title', c: this.social.title, id: 'ogtit' },
        { p: 'og:type', c: 'website', id: 'ogtyp' },
        { p: 'og:url', c: 'https://proyectosees.com/', id: 'ogurl' },
        { p: 'og:image', c: this.social.image, id: 'ogima' },
        { p: 'og:description', c: this.social.description, id: 'ogdes' },
        { p: 'og:site_name', c: 'Proyecto SEES', id: 'ogsit' },
        // { p: 'fb:app_id', c: '123456789' },
      ]
    },
    // link tags
    link: [
      { rel: 'canonical', href: 'https://proyectosees.com/', id: 'canonical' },
      { rel: 'alternate', href: 'https://proyectosees.com/', hreflang: "es-419", id: 'alter' },
    ],
  }
};
</script>
<style>
.scroll-btn {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  border: 2px solid #fff;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  color: #fff;
  font-size: 0.8rem;
  position: absolute;
  bottom: 3rem;
  left: calc(50% - 1.25rem);
  z-index: 999;
  -webkit-animation: bounce 4s 2s infinite;
  animation: bounce 4s 2s infinite;
}
.scroll-btn:hover,
.scroll-btn:focus {
  color: #fff;
  text-decoration: none;
  animation: none;
}

#contact input {
  height: 45px;
}

#contact .has-success:after,
#contact .has-danger:after {
  right: 60px;
}
</style>
